import React from 'react';
import PropTypes from 'prop-types';

export const StripeInstanceContext = React.createContext(null);

export const StripeInstanceContextProvider = ({ children, stripeKey, locale }) => {
  const [stripeInstance, setStripeInstance] = React.useState(null);

  React.useEffect(() => {
    if (stripeKey) {
      const stripe = Stripe.StripeV3(stripeKey, { locale });
      setStripeInstance(stripe);
    }
  }, [stripeKey]);

  return (
    <StripeInstanceContext.Provider
      value={{ stripeInstance }}
    >
      {children}
    </StripeInstanceContext.Provider>
  );
};

StripeInstanceContextProvider.displayName = 'StripeInstanceContextProvider';
StripeInstanceContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  stripeKey: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired
};

export const useStripeInstanceContext = () => {
  const context = React.useContext(StripeInstanceContext);
  if (!context) {
    throw new Error(
      'useStripeInstanceContext must be used within a StripeInstanceContextProvider'
    );
  }
  return context;
};

export const withStripeInstance = (Component) => {
  const WrappedComponent = (props) => {
    const { stripeInstance } = useStripeInstanceContext();
    return <Component {...props} stripeInstance={stripeInstance} />;
  };

  WrappedComponent.displayName =
    Component.displayName || Component.name || 'Component';

  return WrappedComponent;
};
